import { FormField, FormOption } from '@forms';
import { addDays, format, startOfMonth } from 'date-fns';

export const emailFormField: FormField = {
  fieldPlaceholder: '',
  fieldLabel: 'Email Address',
};

export const phoneFormField: FormField = {
  fieldPlaceholder: '',
  fieldLabel: 'Phone Number',
};

export const accountHolderFormField: FormField = {
  fieldPlaceholder: '',
  fieldLabel: 'Name of account holder*',
};

export const accountNumberFormField: FormField = {
  fieldPlaceholder: '',
  fieldLabel: 'Account number*',
};

export const sortcodeFormField: FormField = {
  fieldPlaceholder: '',
  fieldLabel: 'Sort code*',
};

export const paymentDateFormField: FormField = {
  fieldPlaceholder: '',
  fieldLabel: 'Preferred monthly payment date*',
};

export const accountHolderConfirmationFormField: FormField = {
  fieldPlaceholder: '',
  fieldLabel:
    'I confirm that I am the account holder, that these bank details are correct and that I am the only person required to authorise debits from this account.',
};

export const termsAndConditionsFormField: FormField = {
  fieldPlaceholder: '',
  fieldLabel:
    'I confirm that I have read the documents and that this product meets my demands and needs.',
};

export const paperlessFormField: FormField = {
  fieldPlaceholder: '',
  fieldLabel: 'I confirm that I’d like a paper copy of my policy documents.',
};

export const paymentDateOptions: FormOption[] = Array.from(
  { length: 28 },
  (_, index: number) => {
    const date: Date = addDays(startOfMonth(new Date()), index);

    return {
      label: format(date, 'do'),
      value: index + 1,
    };
  },
);
